import DownloadIcon from "@mui/icons-material/Download";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useState } from "react";
import AutoCompleteUIDTO from "../../dto/AutoCompleteUIDTO";
import { generateReportAndDownload } from "../../utils/FileUtils";
import { ButtonComponent } from "../ButtonComponent";
import { FIELD_LABEL_STYLE, ITEM_HEIGHT } from "../SegmentedControl";

interface Props {
  date: Date;
  search: AutoCompleteUIDTO;
  focusProjectNameInput?: any;
  className: string;
}

type Report = { label: string; reportPDFName: string; reportXLSXName: string };

const reportsNames: Report[] = [
  {
    label: "Weekly Dedication Report",
    reportPDFName: "PDF_WEEKLY_HOURS",
    reportXLSXName: "XLSX_WEEKLY_HOURS",
  },
  {
    label: "Daily-Detailed Team Report",
    reportPDFName: "PDF_DAILY_REPORT",
    reportXLSXName: "XLSX_DAILY_REPORT",
  },
  {
    label: "Vacation Report",
    reportPDFName: "PDF_VACATION_REPORT",
    reportXLSXName: "XLSX_VACATION_REPORT",
  },
  {
    label: "Multimonth Worklog Report",
    reportPDFName: "",
    reportXLSXName: "XLSX_MULTIMONTH_REPORT",
  },
];

const WorklogReportDownload = (props: Props) => {
  const { date, search, className } = props;
  const [selectedReport, setSelectedReport] = useState<Report>(reportsNames[0]);

  return (
    <div className={className}>
      <Autocomplete
        fullWidth
        getOptionLabel={(option) => option.label}
        options={reportsNames}
        value={selectedReport}
        onChange={(event, newValue) => {
          setSelectedReport(newValue);
        }}
        renderInput={(params) => <TextField {...params} label="Report" variant="outlined" />}
        size="small"
        disableClearable
      />

      <Box style={{ display: "inline-flex", flexDirection: "column", flexShrink: 0 }}>
        <span style={FIELD_LABEL_STYLE}>Download</span>
        <Box style={{ display: "inline-flex", gap: 10 }}>
          <ButtonComponent
            outlined
            clearStyles
            debounce
            style={{ height: ITEM_HEIGHT.md }}
            icon={<DownloadIcon />}
            text="PDF"
            onClick={() => generateReportAndDownload(selectedReport?.reportPDFName, date, search)}
            disabled={selectedReport === reportsNames.find((r) => r.label === "Multimonth Worklog Report")}
          />
          <ButtonComponent
            outlined
            clearStyles
            style={{ height: ITEM_HEIGHT.md }}
            debounce
            icon={<DownloadIcon />}
            text="XLSX"
            onClick={() => generateReportAndDownload(selectedReport?.reportXLSXName, date, search)}
          />
        </Box>
      </Box>
    </div>
  );
};

export default WorklogReportDownload;
